<div
  class="pdf-viewer-container"
  [class.selection-mode-active]="selectionMode !== 'none'"
  [class.selection-mode-text]="selectionMode === 'text'"
  [class.selection-mode-area]="selectionMode === 'area'"
>
  <!-- Loading State -->
  @if (isLoading) {
    <div class="loading-overlay">
      <mat-spinner diameter="40"></mat-spinner>
      <p>Loading PDF document…</p>
    </div>
  }

  <!-- Error State -->
  @if (hasError && !isLoading) {
    <div class="error-overlay">
      <mat-icon>error_outline</mat-icon>
      <p>{{ errorMessage }}</p>
      <div class="error-actions">
        <button mat-button (click)="loadPdfFile()" color="primary">
          <mat-icon>refresh</mat-icon>
          Try Again
        </button>
      </div>
      @if (getFileExtension() !== 'pdf') {
        <div class="non-pdf-info">
          <mat-icon>info</mat-icon>
          <p>
            This file format cannot be previewed inline. Download the file to view its contents.
          </p>
        </div>
      }
    </div>
  }

  <!-- PDF Viewer -->
  @if (pdfSrc && !isLoading && !hasError) {
    <div class="pdf-viewer-wrapper">
      <ngx-extended-pdf-viewer
        [src]="pdfSrc"
        [height]="'100%'"
        [page]="currentPage"
        (pageChange)="currentPage = $event"
        [handTool]="selectionMode === 'none'"
        [showToolbar]="true"
        [showSidebarButton]="!showMinimalToolbar"
        [showFindButton]="!showMinimalToolbar"
        [showPagingButtons]="true"
        [showZoomButtons]="true"
        [showPresentationModeButton]="false"
        [showOpenFileButton]="false"
        [showPrintButton]="!showMinimalToolbar"
        [showDownloadButton]="true"
        [showSecondaryToolbarButton]="!showMinimalToolbar"
        [showRotateButton]="!showMinimalToolbar"
        [showHandToolButton]="!showMinimalToolbar"
        [showScrollingButtons]="!showMinimalToolbar"
        [showSpreadButton]="!showMinimalToolbar"
        [showPropertiesButton]="false"
        (pagesLoaded)="onPagesRendered()"
        (pageRendered)="onPagesRendered()"
        (zoomChange)="onPagesRendered()"
        class="pdf-viewer-instance"
        >
      </ngx-extended-pdf-viewer>
    </div>
  }

  <!-- No File State -->
  @if (!hasFileUrl && !isLoading) {
    <div class="no-file-overlay">
      <mat-icon aria-hidden="true">description</mat-icon>
      <p>No PDF file available</p>
    </div>
  }
</div>
